import { useEffect, useRef } from 'react'

// Ensures differently from useEffect, that the first render is ignored
const useDidMountEffect = (func: () => void, deps: any[]) => {
  const didMount = useRef(false)

  useEffect(() => {
    if (didMount.current) {
      return func()
    } else {
      didMount.current = true
    }
  }, deps)
}

export default useDidMountEffect
